// @ vendors
const { Promise } = require('es6-promise');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost, APIGet } = require('utilities/APIRequestHelper');

// @ constants
const actionTypes = require('constants/actionTypes');

//@actions
const { requestState } = require('actions/mortgageRequest/mortgageRequestState');

const requestAddEmailInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_ADDEMAIL_REQUEST
});

const requestAddEmailSuccess = (data) => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_ADDEMAIL_SUCCESS,
    data: data
});

const requestAddEmailFailure = (error) => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_ADDEMAIL_FAILURE,
    data: {
        error
    }
});

const saveAddEmailInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_SAVE_ADDEMAIL_REQUEST
});

const saveAddEmailSuccess = () => ({
    type: actionTypes.MORTGAGE_REQUEST_SAVE_ADDEMAIL_SUCCESS
});

const saveAddEmailFailure = (error) => ({
    type: actionTypes.MORTGAGE_REQUEST_SAVE_ADDEMAIL_FAILURE,
    data: {
        error
    }
});

const requestAddEmail = () => (dispatch, getState) => {
    const currentState = getState().mortgageRequestAddEmail;
    const isAlreadyFetching = currentState.get('isFetching');
    if (!isAlreadyFetching) {
        dispatch(requestAddEmailInProgress());
        return APIGet({
            dispatch,
            endpoint: 'mortgageRequestManagerGetEmail'
        })
            .then(response => dispatch(requestAddEmailSuccess(response)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestAddEmailFailure(response.error));
                } else {
                    throw response;
                }
            })
    } else {
        return Promise.resolve()
    }
};

const saveAddEmail = (history) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestAddEmail;
    const currentStatusState = getState().mortgageRequestState;
    const isAlreadyFetching = currentState.get('isFetching');
    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                'email': currentState.get('email'),
                'fechaObjetivo': currentStatusState.get('fechaObjetivo')
            }
        };

        const url = apiURLBuilder.getURL('mortgageRequestManagerAddEmail');

        dispatch(saveAddEmailInProgress());
        return APIPost({
            dispatch,
            endpoint: 'mortgageRequestManagerAddEmail',
            url,
            params: requestData
        })
            .then(() => {
                dispatch(saveAddEmailSuccess());
                dispatch(requestState('/myprofile/mortgage/panel', history));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(saveAddEmailFailure(response.error));
                } else {
                    throw response;
                }
            })
    } else {
        return Promise.resolve()
    }
};

const setEmail = (email, emailChange, emailValid) => ({
    type: actionTypes.MORTGAGE_REQUEST_UPDATE_ADDEMAIL_SUCCESS,
    data: {
        newEmail: email,
        newEmailValid: emailValid,
        newEmailChange: emailChange
    }
});

const setPrivacy = (privacyValid) => ({
    type: actionTypes.MORTGAGE_REQUEST_UPDATE_PRIVACY_SUCCESS,
    data: {
        privacyValid
    }
});

module.exports = {
    requestAddEmail,
    saveAddEmail,
    setEmail,
    setPrivacy
};
